import {addHeaders, get, post} from "../utils/api/api";
import storage from "../utils/storage";

const apiUrl = 'https://240000-231206.dev.peppers-studio.ru/api/v1/';

const _storage = storage("info", ({access_token} = {}) => {
  addHeaders({
    "Authorization": access_token ? `Bearer ${access_token}` : false
  })
});
_storage.load()


export function login(data) {
  return post(`${apiUrl}user/login`, data)
    .then(saveAuth)
}

export function signup(data) {
  return post("/user/signup", data)
    .then(saveAuth)
}

export function update(data) {
  return post("/user/update", data)
}

export function profile() {
  return get(`${apiUrl}user/profile`)
}

export function logout() {
  return post("/user/logout")
    .then(saveAuth)
}

function saveAuth(data) {
  _storage.save(data?.profile);

  return data;
}

